import React from 'react';
import IndustriesCTA from './IndustriesCTA';
import IndustriesGrid from './IndustriesGrid';
import IndustriesHero from './IndustriesHero';
import { industriesData } from '../../utils/industriesData';
import SEO from '../SEO/SEO';
import { BreadcrumbSchema } from '../SEO/StructuredData';

const IndustriesPageLayout: React.FC = () => {
  return (
    <main className="pt-[72px] bg-white">
      <SEO
        title="Industries"
        description="See how Cool & Care supports commercial, industrial, residential, and public-sector clients with security, HVAC, fire safety, solar, and software services in DRC."
        keywords="industries served DRC, commercial security, industrial HVAC, fire safety solutions, solar services Kinshasa"
      />
      <BreadcrumbSchema items={[{ name: 'Industries', url: '/industries' }]} />
      <IndustriesHero />
      <IndustriesGrid items={industriesData} />
      <IndustriesCTA />
    </main>
  );
};

export default IndustriesPageLayout;
